import * as React from 'react';
import { st, classes } from './Backdrop.st.css';
var Backdrop = function (_a) {
    var onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React.createElement("div", { onClick: onClick, className: st(classes.root, {}, className) }));
};
export default Backdrop;
//# sourceMappingURL=Backdrop.js.map